import { Suspense } from 'react';

import { PopUp as PopUpComponent, PopUpProps } from '@/ui';

import { BlockBase } from './utils';

export function PopUp({
  params,
  automaticToggle,
  automaticToggleDelay,
  triggerId,
  maxAge,
  pageContent,
}: PopUpProps & BlockBase) {
  return (
    <Suspense>
      <PopUpComponent
        pageContent={pageContent}
        params={params}
        maxAge={maxAge}
        automaticToggle={automaticToggle}
        automaticToggleDelay={automaticToggleDelay}
        triggerId={triggerId}
      />
    </Suspense>
  );
}
